import { createStore } from 'vuex'

export default createStore({
  state: {
    app: {
      name: "Vue Admin Template"
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
